"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  id: 1,
  name: "Alice Johnson",
  role: "Senior Accountant",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/alice_johnson_portrait.png"
}, {
  id: 2,
  name: "David Lee",
  role: "Financial Consultant",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/david_lee_portrait.png"
}, {
  id: 3,
  name: "Sarah Mitchell",
  role: "Tax Specialist",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/sarah_mitchell_portrait.png"
}, {
  id: 4,
  name: "Michael Chen",
  role: "Business Advisor",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/michael_chen_portrait.png"
}, {
  id: 5,
  name: "Emma Taylor",
  role: "Payroll Manager",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/emma_taylor_portrait.png"
}, {
  id: 6,
  name: "James Wilson",
  role: "Audit Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/james_wilson_portrait.png"
}];
export default function Team() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="team" ref={ref} className="bg-background py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="mb-16 text-center">
          <h2 className="mb-4 text-[36px] font-semibold leading-[1.3] tracking-[-0.2px] text-foreground">
            Meet Our Expert Team
          </h2>
          <p className="mx-auto max-w-2xl text-[16px] leading-[1.6] text-muted-foreground">
            Our dedicated professionals bring years of experience and expertise to help your business thrive.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {teamMembers.map((member, i) => <Card key={member.id} data-index={i} className="group cursor-pointer border border-border bg-surface text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:shadow-[0_6px_14px_rgba(0,0,0,0.1),0_2px_4px_rgba(0,0,0,0.04)]" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(20px)",
          transition: `opacity var(--duration-medium) var(--ease-smooth) ${i * 200}ms, transform var(--duration-medium) var(--ease-smooth) ${i * 200}ms`
        }}>
              <CardContent className="flex flex-col items-center pt-6">
                <SafeHydrate><Avatar className="mb-4 size-24 border-2 border-primary">
                  <AvatarImage src={member.image} alt={member.name} />
                  <AvatarFallback className="bg-primary-light text-[20px] font-semibold text-primary">
                    {member.name.split(" ").map(n => n[0]).join("")}
                  </AvatarFallback>
                </Avatar></SafeHydrate>
                <h4 className="mb-2 text-[22px] font-semibold leading-[1.5] text-foreground transition-all duration-[var(--duration-fast)] group-hover:font-bold">
                  {member.name}
                </h4>
                <p className="text-[14px] leading-[1.5] text-muted-foreground">
                  {member.role}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}